// Eventos de funil/marketing. ANTES de 05/10/2026 o fitclutch-app não tinha
// NENHUM tracking (nenhum gtag/fbq/GA4/Meta no código nem no index.html).
// Este helper é um ponto único e seguro: se algum pixel/GTM for instalado
// depois (window.dataLayer / gtag / fbq), os eventos já fluem; se não
// houver nada, não faz nada (nunca quebra a página).
const FB_MAP = { paywall_view: 'ViewContent', begin_checkout: 'InitiateCheckout' };

export function track(name, params = {}) {
  try {
    if (typeof window === 'undefined') return;
    window.dataLayer?.push({ event: name, ...params });
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
    if (typeof window.fbq === 'function') {
      if (FB_MAP[name]) window.fbq('track', FB_MAP[name], params);
      else window.fbq('trackCustom', name, params);
    }
  } catch {
    /* tracking nunca pode derrubar a tela */
  }
}
